import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ClimateMeteoService {
  constructor() {}

  filteredMeteoArray(
    meteoArray: any[],
    meteoVisibility: { [key: string]: any }
  ): any[] {
    const visibleKeys = new Set(
      meteoVisibility.filter((item) => item.visible).map((item) => item.key)
    );

    const visibleMeteoArray = meteoArray.filter((item) =>
      visibleKeys.has(item.key)
    );

    return this.orderMeteoArray(visibleMeteoArray);
  }

  orderMeteoArray(meteoArray: any[]): any[] {
    const orderKeys = [
      'Met_temp',
      'Met_hum',
      'Met_windSpeed',
      'Met_windDir',
      'Met_instRad',
      'Met_cummRad',
      'Met_rain,',
      'Met_stormAl1',
      'Met_stormAl2',
      'Met_freezeAl',
      'Met_pluv',
      'Met_day',
      'Met_time',

      'TEMPERATURE',
      'HUMIDITY',
      'WIND_VELOCITY',
      'WIND_DIRECTION',
      'RADIATION',
      'ACCUMULATED_RADIATION',
      'PLUVIOMETER',
      'RAIN',
      'ET0',
      'SUNRISE',
      'SUNSET',
    ];

    const keyOrderMap = new Map(orderKeys.map((key, index) => [key, index]));

    const orderedMeteoArray = meteoArray.sort((a, b) => {
      const orderA = keyOrderMap.get(a.key) ?? Number.MAX_SAFE_INTEGER;
      const orderB = keyOrderMap.get(b.key) ?? Number.MAX_SAFE_INTEGER;
      return orderA - orderB;
    });

    return orderedMeteoArray;
  }
}
